import script from "./ProductPurchaseOptions.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductPurchaseOptions.vue?vue&type=script&setup=true&lang=js"

import "./ProductPurchaseOptions.vue?vue&type=style&index=0&id=4594f9ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4594f9ac"]])

export default __exports__